// Components==============
import { useRedux } from 'hooks/useRedux';
import { useRootModal } from 'hooks/useRootModal';
import React from 'react';
import ReflectionIcon from '../ReflectionIcon/ReflectionIcon';
import SkillModal from '../SkillModal/SkillModal';
import './SkillGetter.module.scss';
// =========================

export default function SkillGetter({
  id,
  handleDelete,
}: {
  id: number;
  handleDelete?: () => void;
}) {
  const { setModal } = useRootModal();

  const skill = useRedux((state) => state.skill?.entities.byId[id]);

  if (!skill) return <></>;

  return (
    <ReflectionIcon
      key={skill?.icon}
      image={`/storage/${skill.icon}`}
      name={skill?.name}
      type="skill"
      onClick={() => setModal(<SkillModal selectedSkill={skill} />)}
      handleDelete={handleDelete}
    />
  );
}
